"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonGroup = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonGroupMixin = require("../../mixins/components/ButtonGroupMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledButtonGroup = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['conjoined', 'direction', 'fluid'])
}).withConfig({
  displayName: "StyledButtonGroup",
  componentId: "c11n-8-107-0__sc-1v59d24-0"
})(["", ""], _ButtonGroupMixin.ButtonGroupMixin);
exports.StyledButtonGroup = StyledButtonGroup;